function HomeInfobox(el) {
    this.el = el;
    this.elInner = this.el.querySelector('.jsHomeInfoboxInner');

    this.focusedElBeforeOpen = null;
    this.focusableEls = this.el.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
    this.firstFocusableEl = this.focusableEls[0];
    this.lastFocusableEl = this.focusableEls[this.focusableEls.length - 1];

    this.el.addEventListener('click', e => {
        if (e.target.classList.contains('jsHomeInfoboxClose')) {
            e.preventDefault();
            this.hide();
        }
    });

    window.addEventListener('keyup', e => {
        if (e.key.toLowerCase() === 'escape') this.hide();
    });

    window.addEventListener('keydown', e => {
        const tabIsPressed = e.key === 'Tab';

        if (!tabIsPressed) return;

        if (e.shiftKey) {
            if (document.activeElement === this.firstFocusableEl) {
                this.lastFocusableEl.focus();
                e.preventDefault();
            }
        }
        else {
            if (document.activeElement === this.lastFocusableEl) {
                this.firstFocusableEl.focus();
                e.preventDefault();
            }
        }
    });
}

HomeInfobox.prototype.show = function(clickedTarget) {
    if ((typeof clickedTarget !== undefined || clickedTarget !== null) && clickedTarget) {
        const parentSectionEl = clickedTarget.closest('.jsHomeSection');

        if (parentSectionEl) this.setFocusToSection(parentSectionEl, _ => this._show());
        else this._show();
    }
    else {
        this._show();
    }
};

HomeInfobox.prototype._show = function() {
    document.body.classList.add('infobox-open');

    gsap.timeline()
        .set(this.el, { opacity: 0 })
        .set(this.elInner, { xPercent: 100 })

        .add(_ => {
            this.el.classList.add('show');
            this.firstFocusableEl.focus();
        })

        .to(this.el, 0.5, { opacity: 1, ease: Power2.easeInOut })
        .to(this.elInner, 0.5, { xPercent: 0, ease: Power2.easeInOut }, '-=0.2')
    ;

    // Accessibility stuff
    this.focusedElBeforeOpen = document.activeElement;
    document.body.ariaHidden = true;
    this.el.ariaHidden = false;
};

HomeInfobox.prototype.hide = function() {
    document.body.classList.remove('infobox-open');

    gsap.timeline()
        .to(this.elInner, 0.5, { xPercent: 100, ease: Power2.easeInOut })
        .to(this.el, 0.5, { opacity: 0, ease: Power2.easeInOut }, '-=0.2')
        .add(_ => this.el.classList.remove('show'));
    ;

    // Accessibility stuff
    this.focusedElBeforeOpen.focus();
    this.focusedElBeforeOpen = null;
    document.body.ariaHidden = false;
    this.el.ariaHidden = true;
};

HomeInfobox.prototype.setFocusToSection = function(sectionEl, callback) {
    if (callback) callback();
    return;
    // const bounds = sectionEl.getBoundingClientRect();

    // vanillaSmoothie.scrollTo(window.scrollY + bounds.top, { duration: 500, easing: 'easeOutQuad' });
    // setTimeout(callback, 250);
};

(function() {
    const infoboxes = {};

    document.addEventListener('click', e => {
        if (e.target.classList.contains('jsHomeInfoboxTrigger')) {
            if (e.target.dataset.infoboxId) {
                const infoboxId = e.target.dataset.infoboxId;

                // Play a sound
                if (typeof globalSoundIsOn !== 'undefined' && globalSoundIsOn === true) {
                    const clickSound = new Audio(clickSoundUrl);
                    clickSound.play();
                }

                if (typeof infoboxes[infoboxId] !== 'undefined') {
                    infoboxes[infoboxId].show(e.target);
                }
                else {
                    // Get the infobox element
                    const boxEl = document.body.querySelector('.jsHomeInfobox[data-infobox-id="' + infoboxId + '"]');

                    // Create the infobox and show it
                    if (boxEl) {
                        infoboxes[infoboxId] = new HomeInfobox(boxEl);
                        infoboxes[infoboxId].show(e.target);
                    }
                    else {
                        console.error('Cannot find an infobox with id', infoboxId);
                    }
                }
            }
            else {
                console.error('Target has no infobox id');
            }
        }
    });
})();